// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions
// .MarketDataIntegration (GroupName = "HostPages").
export const MarketDataIntegrationPermissions = {
  view: 'HostPages.MarketDataIntegration',
  run: 'HostPages.MarketDataIntegration.Run',
  stop: 'HostPages.MarketDataIntegration.Stop',
  export: 'HostPages.MarketDataIntegration.Export',
} as const;
